import React from 'react'
import Money from '../../types/Money'
import CurrencySelector from '../CurrencySelector/CurrencySelector'
import InputForm from './InputForm'
import styles from './MoneyInputForm.module.css'

interface MoneyInputFormProps {
    money: Money
    onChangeAmount: (amount: string) => void
    onChangeCurrency: (currency: string) => void
    errorMessage?: string
}

const MoneyInputForm = ({ money, onChangeAmount, onChangeCurrency, errorMessage }: MoneyInputFormProps) => {
    return <>
        <div className={styles.amountInputs}>
            <div className={styles.amountInputGroup}>
                <InputForm
                    label=""
                    type="number"
                    name="amount"
                    value={money.amount}
                    placeholder="100.00"
                    onChange={(e) => onChangeAmount(e.target.value)}
                    step={1.00}
                    min={1}
                    errorMessage={errorMessage || undefined}
                />
                <div className={styles.currencySelector}>
                    <CurrencySelector value={money.currency} onChange={onChangeCurrency} />
                </div>
            </div>
        </div>
        {errorMessage && <span className={styles.error}>{errorMessage}</span>}
    </>
}

export default MoneyInputForm
